/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_AudioInputs */

const zh_sidebar_audio = /** @type {(inputs: Sidebar_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`音频`)
};

const en_sidebar_audio = /** @type {(inputs: Sidebar_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio`)
};

const es_sidebar_audio = /** @type {(inputs: Sidebar_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio`)
};

/**
* | output |
* | --- |
* | "Audio" |
*
* @param {Sidebar_AudioInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const sidebar_audio = /** @type {((inputs?: Sidebar_AudioInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_AudioInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_audio(inputs)
	if (locale === "en") return en_sidebar_audio(inputs)
	return es_sidebar_audio(inputs)
});